import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '../uiold';

import { Tag } from '../../types/shared/Tag';

type Props = {
  tag: Tag;
  hasMargin?: boolean;
};

export default function TagItem({ tag, hasMargin = true }: Props) {
  return (
    <Text
      title={tag.name}
      style={[
        styles.circle,
        { backgroundColor: tag.color, marginHorizontal: hasMargin ? 1 : 0 },
      ]}
    />
  );
}

let styles = StyleSheet.create({
  circle: {
    height: 10,
    width: 10,
    borderRadius: 5,
  },
});
